'use client';

import Script from 'next/script';
import { useState } from 'react';

export function ResetCMP() {
  const [consentLoaded, setConsentLoaded] = useState(false);

  return (
    <p className="py-3 px-0 max-w-[500px] leading-relaxed">
      {consentLoaded && (
        <Script
          src="https://gdpr-tcfv2.sp-prod.net/wrapperMessagingWithoutDetection.js"
          onLoad={() => {
            window._sp_.loadPrivacyManagerModal(188325);
          }}
        />
      )}
      <button
        onClick={() => {
          if (window._sp_.loadPrivacyManagerModal) {
            window._sp_.loadPrivacyManagerModal(188325);
          } else {
            setConsentLoaded(true);
          }
        }}
        title="Cookie-Banner erneut aufrufen"
        className="cursor-pointer text-primaryColor text-left"
      >
        Zum Ändern der Präferenzen oder Widerruf der Einwilligung: Cookie-Banner
        erneut aufrufen
      </button>
    </p>
  );
}
